
<section class="crg-manager" role="dialog" aria-modal="true" [attr.aria-label]="'app.countryRegulations.title' | translate">

  <!-- PROCESSING OVERLAY -->
  @if (isProcessing) {
    <div class="processing-wrapper">
      <div class="processing-circle"></div>
      <div class="processing-text">
        {{ "app.misc.processing" | translate }}
      </div>
    </div>
  }

  <!-- HEADER -->
  <header class="crg-header">
    <div class="heading">
      <mat-icon class="globe">language</mat-icon>
      <div>
        <h2>{{ 'app.countryRegulations.title' | translate }}</h2>
        <p>{{ 'app.countryRegulations.subtitle' | translate }}</p>
      </div>
    </div>

    <button type="button" class="close-icon" (click)="close()"
      [attr.aria-label]="'app.countryRegulations.close' | translate">×</button>
  </header>

  <!-- TABLE FRAME -->
  <div class="table-frame">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th class="actions">{{ 'app.countryRegulations.actions' | translate }}</th>
            <th>{{ 'app.countryRegulations.countryCode' | translate }}</th>
            <th class="boolean">{{ 'app.countryRegulations.europeanUnion' | translate }}</th>
            <th class="boolean">{{ 'app.countryRegulations.active' | translate }}</th>
          </tr>
        </thead>

        <tbody>
          <!-- ADD ROW -->
          <tr class="add-row">
            <td class="action-buttons">
              <button type="button" class="icon-button edit" (click)="beginAdd()" [disabled]="busy"
                [attr.title]="'app.countryRegulations.add' | translate">
                <span aria-hidden="true">+</span>
              </button>

              <button type="button" class="icon-button save" (click)="save(newRow, true)" [disabled]="!adding"
                [attr.title]="'app.countryRegulations.save' | translate">
                <mat-icon>save</mat-icon>
              </button>

              <button type="button" class="icon-button delete" disabled
                [attr.title]="'app.countryRegulations.delete' | translate">
                <mat-icon>delete</mat-icon>
              </button>

              <button *ngIf="adding" type="button" class="icon-button cancel" (click)="cancel()"
                [attr.title]="'app.countryRegulations.cancel' | translate">×</button>
            </td>

            <td>
              <input class="country-input" maxlength="2" [disabled]="!adding"
                id="newCountryCode"
                name="newCountryCode"              
                [(ngModel)]="newRow.CRG_CountryCode"
                [placeholder]="'app.countryRegulations.newCountry' | translate"
                (keyup.enter)="adding && save(newRow, true)" />
            </td>

            <td class="boolean">
              <input type="checkbox" class="switch" [(ngModel)]="newRow.CRG_IsEuropeanUnion"
                [disabled]="!adding" />
            </td>

            <td class="boolean">
              <input type="checkbox" class="switch" [(ngModel)]="newRow.CRG_IsActive"
                [disabled]="!adding" />
            </td>
          </tr>

          <!-- EXISTING ROWS -->
          <tr *ngFor="let row of displayRows" [class.editing]="isEditing(row)">
            <td class="action-buttons">
              <button type="button" class="icon-button edit" (click)="edit(row)" [disabled]="busy"
                [attr.title]="'app.countryRegulations.edit' | translate"
                [attr.aria-label]="'app.countryRegulations.edit' | translate">
                <span aria-hidden="true">✎</span>
              </button>

              <button type="button" class="icon-button save" (click)="save(row)" [disabled]="!isEditing(row)"
                [attr.title]="'app.countryRegulations.save' | translate"
                [attr.aria-label]="'app.countryRegulations.save' | translate">
                <mat-icon>save</mat-icon>
              </button>

              <button type="button" class="icon-button delete" (click)="remove(row)" [disabled]="busy"
                [attr.title]="'app.countryRegulations.delete' | translate"
                [attr.aria-label]="'app.countryRegulations.delete' | translate">
                <mat-icon>delete</mat-icon>
              </button>

              <button *ngIf="isEditing(row)" type="button" class="icon-button cancel" (click)="cancel()"
                [attr.title]="'app.countryRegulations.cancel' | translate">×</button>
            </td>

            <td>
              <ng-container *ngIf="isEditing(row); else countryLabel">
                <input [(ngModel)]="row.CRG_CountryCode" maxlength="2"
                  class="country-input"
                  [attr.aria-label]="'app.countryRegulations.countryCode' | translate"
                  (keyup.enter)="save(row)" />
              </ng-container>

              <ng-template #countryLabel>
                <span class="country-display">
                  <img class="country-flag"
                    [src]="'https://flagcdn.com/w40/' + row.CRG_CountryCode.toLowerCase() + '.png'"
                    [alt]="row.CRG_CountryCode + ' flag'"
                    width="28" height="20" />
                  <strong>{{ row.CRG_CountryCode }}</strong>
                </span>
              </ng-template>
            </td>

            <td class="boolean">
              <input type="checkbox" class="switch" [(ngModel)]="row.CRG_IsEuropeanUnion"
                [disabled]="!isEditing(row)"
                [attr.aria-label]="'app.countryRegulations.europeanUnion' | translate" />
            </td>

            <td class="boolean">
              <input type="checkbox" class="switch" [(ngModel)]="row.CRG_IsActive"
                [disabled]="!isEditing(row)"
                [attr.aria-label]="'app.countryRegulations.active' | translate" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- FOOTER -->
  <footer>
    <span>{{ regulations.length }} {{ 'app.countryRegulations.records' | translate }}</span>
    <button type="button" class="close-button" (click)="close()">
      {{ 'app.countryRegulations.close' | translate }}
    </button>
  </footer>

</section>
